import React from "react";

import { Pill } from "@lattice/frontend/components/kit/Pill";

import "../chat-v8.css";

export function PromptChipRow({
  onPress,
  prompts,
}: {
  onPress: (prompt: string) => void;
  prompts: string[];
}) {
  if (prompts.length === 0) return null;
  return (
    <div className="chat-v8-pill-row">
      {prompts.map((prompt) => (
        <Pill key={prompt} label={prompt} onClick={() => onPress(prompt)} />
      ))}
    </div>
  );
}
